/** What every wreck is made of: burnt chunks, a scorch on the ground, and the tones of burnt paint. */

import type { Pcg32 } from '../../sim/rng';
import type { Palette } from '../palette';
import { type BoxColors, type MeshBuilder, place } from './MeshBuilder';

const TAU = Math.PI * 2;

/** Scatter of small burnt chunks over a half-extent rectangle. */
export function debris(mb: MeshBuilder, p: Palette, rng: Pcg32, count: number, halfX: number, halfZ: number): void {
  for (let i = 0; i < count; i++) {
    const tone = p.color(rng.chance(0.6) ? 'ink.1' : 'metal.lo');
    const at = place(rng.range(-halfX, halfX), 0, rng.range(-halfZ, halfZ), rng.range(0, TAU), 1, rng.range(-0.3, 0.3));
    mb.box(rng.range(0.3, 0.8), rng.range(0.12, 0.35), rng.range(0.3, 0.7), tone, at);
  }
}

/** A burnt patch on the ground under a wreck, thick enough not to be swallowed by rough ground. */
export function scorch(mb: MeshBuilder, p: Palette, w: number, d: number, x = 0, z = 0, yaw = 0): void {
  mb.box(w, 0.08, d, p.color('ink.1'), place(x, 0, z, yaw));
}

/** Burnt plate: soot on the sides, a little of the old metal still showing on top. */
export function burnt(p: Palette): BoxColors {
  return { all: p.color('ink.1'), top: p.color('metal.lo') };
}
